import React from 'react';
import slide1 from 'assets/images/articles/trainingfaq.webp';
import styles from './styles.module.scss';
import FooterABC from '../../containers/Footer/footerABC';
import { textGuide } from '../../utils/MetaDecorator/meta';
import MetaDecorator from '../../utils/MetaDecorator';
import FAQSlideTraining from '../../components/FAQSlideTraining';

const slides = [{
  slide: slide1,
  rules: [
    {
      color: '#E9FF66',
      content: 'trainingFaqText1',
      sideContent: [
        { main: 'trainingFaqText1_1' },
        { main: 'trainingFaqText1_2' },
        { main: 'trainingFaqText1_3' },
      ],
    },
    {
      color: '#E9FF66',
      content: 'trainingFaqText2',
      sideContent: [
        { main: 'trainingFaqText2_1' },
      ],
    },
    {
      color: '#E9FF66',
      content: 'trainingFaqText3',
      sideContent: [
        { main: 'trainingFaqText3_1' },
        { main: 'trainingFaqText3_2' },
        { main: 'trainingFaqText3_3' },
        { main: 'trainingFaqText3_4' },
        { main: 'trainingFaqText3_5' },
      ],
    },
    { color: '#E9FF66', content: 'trainingFaqText4', sideContent: [] },
    { color: '#E9FF66', content: 'trainingFaqText5', sideContent: [] },
    {
      color: '#E9FF66',
      content: 'trainingFaqText6',
      sideContent: [
        { main: 'trainingFaqText6_1' },
        { main: 'trainingFaqText6_2' },
        { main: 'trainingFaqText6_3' },
        { main: 'trainingFaqText6_4' },
        { main: 'trainingFaqText6_5' },
        { main: 'trainingFaqText6_6' },
        { main: 'trainingFaqText6_7' },
        { main: 'trainingFaqText6_8' },
        { main: 'trainingFaqText6_9' },
        { main: 'trainingFaqText6_10' },
        { main: 'trainingFaqText6_11' },
        { main: 'trainingFaqText6_12' },
        { main: 'trainingFaqText6_13' },
        { main: 'trainingFaqText6_14' },
      ],
    },
    {
      color: '#E9FF66',
      content: 'trainingFaqText7',
      sideIsFlex: true,
      sideContent: [
        { main: 'trainingFaqText7_1', secondary: ['30 - 30 bb', '50 - 50 bb', '100 - 100 bb', '200 - 200 bb'] },
        { main: 'trainingFaqText7_2', secondary: ['10 - 10 bb', '30 - 30 bb', '50 - 50 bb', '100 - 100 bb'] },
        { main: 'trainingFaqText7_3', secondary: ['10 - 10 bb', '20 - 20 bb', '30 - 30 bb', '40 - 40 bb', '50 - 50bb'] },
        { main: 'trainingFaqText7_4', secondary: ['20 - 20 bb', '30 - 30 bb', '40 - 40 bb', '50 - 50 bb'] },
        { main: 'trainingFaqText7_5', secondary: ['10 - 10 bb', '20 - 20 bb', '30 - 30 bb', '40 - 40 bb', '50 - 50 bb'] },
        { main: 'trainingFaqText7_6', secondary: ['10 - 10 bb', '20 - 20 bb', '30 - 30 bb', '40 - 40 bb', '50 - 50 bb'] },
        { main: 'trainingFaqText7_7', secondary: ['20 - 20 bb', '50 - 50 bb', '100 - 100 bb', '150 - 150 bb', '200 - 200 bb'] },
      ],
    },
    { color: '#E9FF66', content: 'trainingFaqText8', sideContent: [] },
    { color: '#E9FF66', content: 'trainingFaqText9', sideContent: [] },
    { color: '#E9FF66', content: 'trainingFaqText10', sideContent: [] },
    { color: '#E9FF66', content: 'trainingFaqText11', sideContent: [] },
    { color: '#E9FF66', content: 'trainingFaqText12', sideContent: [] },
    { color: '#E9FF66', content: 'trainingFaqText13', sideContent: [] },
    { color: '#E9FF66', content: 'trainingFaqText14', sideContent: [] },
    { color: '#E9FF66', content: 'trainingFaqText15', sideContent: [] },
    { color: '#E9FF66', content: 'trainingFaqText16', sideContent: [] },
    { color: '#E9FF66', content: 'trainingFaqText17', sideContent: [] },
    { color: '#E9FF66', content: 'trainingFaqText18', sideContent: [] },
    { color: '#E9FF66', content: 'trainingFaqText19', sideContent: [] },
    { color: '#E9FF66', content: 'trainingFaqText20', sideContent: [] },
    { color: '#E9FF66', content: 'trainingFaqText21', sideContent: [] },
    { color: '#E9FF66', content: 'trainingFaqText22', sideContent: [] },
    { color: '#E9FF66', content: 'trainingFaqText23', sideContent: [] },
    { color: '#E9FF66', content: 'trainingFaqText24', sideContent: [] },
  ],
},
];

const TrainingFAQ = () => {
  console.log('');
  return (
    <section className={styles.faqWrapper}>
      <MetaDecorator
        description={textGuide.description}
        title={textGuide.title}
      />
      {slides.map((slide) => (
        <FAQSlideTraining
          image={slide.slide}
          title={slide.title}
          rules={slide.rules}
        />
      ))}
      <FooterABC />
    </section>
  );
};

export default TrainingFAQ;
